
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const CancellationRefund = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Cancellation and Refund Policy</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-4">
              At CareerGuideKerala.in, we aim to provide high-quality career guidance services tailored to your needs.
            </p>
            
            <p className="text-gray-600 mb-4">
              Please note that once the product (career guidance report or any other digital product) is delivered, 
              cancellation and refund will not be possible due to the nature of the service.
            </p>
            
            <p className="text-gray-600 mb-4">
              This is because the product involves personalized recommendations and insights, which are generated 
              based on the answers provided by you.
            </p>
            
            <p className="text-gray-600 mb-4">
              If you face any issues with the delivery or the content, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>{" "}
              and we will assist you promptly.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Before Purchase</h2>
            <p className="text-gray-600 mb-4">
              Before making a purchase, we encourage you to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Read the product description carefully</li>
              <li>Understand what the service entails</li>
              <li>Contact us if you have any questions about the service</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Exceptional Circumstances</h2>
            <p className="text-gray-600 mb-4">
              While we maintain a no-refund policy for delivered digital products, we understand that exceptional 
              circumstances may arise. In such cases, we will review refund requests on a case-by-case basis.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Contact Us</h2>
            <p className="text-gray-600 mb-4">
              For any questions or concerns regarding our cancellation and refund policy, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default CancellationRefund;
